import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const Founder = () => {
 return (
 <div className="founder-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">Founder</h1>
 <p className="page-subtitle">
 Authority through lived experience.
 </p>
 </div>
 </section>

 <section className="founder-intro-section">
 <div className="section-container">
 <div className="founder-content">
 <Card className="founder-card">
 <CardContent className="founder-card-content">
 <p>
 Nova Roots was founded by an educator, parent, and systems thinker who spent years 
 observing what works—and what doesn't—in education.
 </p>
 <p>
 The vision for Nova Roots emerged from deep frustration with exam-driven schooling, 
 disconnection from real life, and the lack of truly child-centred alternatives in Kenya.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="background-section">
 <div className="section-container">
 <h2 className="section-title">Background & Experience</h2>
 <div className="background-content">
 <Card className="background-card">
 <CardContent>
 <h3>Education & Pedagogy</h3>
 <p>
 Extensive study of progressive education models including Montessori, Waldorf, Reggio Emilia, 
 and mastery-based learning. Deep understanding of child development, learning science, and 
 pedagogical approaches that honour how children actually learn.
 </p>
 </CardContent>
 </Card>

 <Card className="background-card">
 <CardContent>
 <h3>Technology & Systems</h3>
 <p>
 Experience working with learning technology platforms, personalised education systems, and 
 data-informed decision-making. Expertise in integrating technology thoughtfully without 
 allowing it to dominate or replace human judgment.
 </p>
 </CardContent>
 </Card>

 <Card className="background-card">
 <CardContent>
 <h3>African Context</h3>
 <p>
 Deep roots in Kenya. Understanding of local context, cultural values, and the unique 
 opportunities and challenges of building alternative education in Nairobi. Commitment to 
 creating something authentically African, not imported.
 </p>
 </CardContent>
 </Card>

 <Card className="background-card">
 <CardContent>
 <h3>Entrepreneurship & Systems Design</h3>
 <p>
 Experience building organisations from the ground up. Ability to design systems, manage 
 complexity, and create structures that serve mission rather than bureaucracy.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="philosophy-section">
 <div className="section-container">
 <h2 className="section-title">Why Nova Roots?</h2>
 <div className="philosophy-content">
 <Card className="philosophy-card">
 <CardContent>
 <p>
 "I built Nova Roots because I believe children deserve better. They deserve to be seen, 
 trusted, and prepared for real life—not just exams.
 </p>
 <p>
 I've watched too many brilliant children lose their curiosity in schools that prioritise 
 compliance over thinking. I've seen families struggle to find alternatives that are rigorous, 
 grounded, and culturally rooted.
 </p>
 <p>
 Nova Roots is my answer to that problem. It's not perfect, and it's not for everyone. But 
 it's built with care, integrity, and a deep commitment to doing right by children."
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="commitment-section">
 <div className="section-container">
 <div className="commitment-box">
 <h2>A Personal Commitment</h2>
 <p>
 Nova Roots is not a business venture or an experiment. It's a long-term commitment to building 
 education that works—one child, one family, one community at a time.
 </p>
 <p>
 The founder remains deeply involved in every aspect of the school: curriculum design, Walezi 
 training, family conversations, and day-to-day operations. This is not delegated. It's personal.
 </p>
 </div>
 </div>
 </section>

 <section className="vision-section">
 <div className="section-container">
 <div className="vision-box">
 <h2>Looking Ahead</h2>
 <p>
 Nova Roots begins as a micro school—small, focused, and intentional. The vision is to prove the 
 model, refine the approach, and eventually expand to serve more families without losing the depth 
 and care that makes it work.
 </p>
 <p>
 This is not about rapid growth. It's about building something sustainable, credible, and genuinely 
 transformative.
 </p>
 </div>
 </div>
 </section>
 </div>
 );
};

export default Founder;